import Breadcrumb from "../components/Breadcrumb";
import ShopFirstSection from "../components/Shop/ShopFirstSection";
import ShopProducts from "../components/Shop/ShopProducts";

const Shop = () => {
  return (
    <div>
      <Breadcrumb curPage={"shop"} />
      <ShopFirstSection />
      <ShopProducts />
    </div>
  );
};

export default Shop;
